import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Button, Flex } from '@mantine/core';
import { useState } from 'react';
import { useBaleInboundContext } from '../hook';

export const ManualCreateScanRemovePage = () => {
	const { setPage, handleManualCreateBaleScan, manualCodeEntryOpen, setManualCodeEntryOpen } =
		useBaleInboundContext();
	const [code, setCode] = useState('');

	const handleBack = () => {
		setPage('MANUAL_CREATE:ROOT');
	};

	return (
		<MobileContainer header={<MobileHeader title="Remove Bales" onBack={handleBack} />}>
			<Scanner onScan={(code) => handleManualCreateBaleScan('REMOVE', code)} />
			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={manualCodeEntryOpen}
				instructions="Please enter the code found on the bale tag to remove it from this load."
				onClose={() => setManualCodeEntryOpen(false)}
				shouldValidate
				actions={({ isValid, onClose }) => {
					return (
						<Flex gap="sm">
							<Button
								variant="filled"
								fullWidth
								onClick={() => {
									onClose();
									setCode('');
								}}
							>
								Cancel
							</Button>
							<Button
								variant="filled"
								color="red"
								fullWidth
								onClick={() => handleManualCreateBaleScan('REMOVE', code)}
								disabled={!isValid}
							>
								Remove Bale
							</Button>
						</Flex>
					);
				}}
			/>
		</MobileContainer>
	);
};
